import { createContext, useContext } from "react";
import jwt_decode from "jwt-decode";

export const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

//Query user info from token
export const getLoggedUser = () => {
  //This field only has value if role in (processor, lab user)
  let processorId = "";
  let processorCertificateNo = "";
  let processorCertificatePrefix = "";
  let processorCertificateSeed = "";
  let processorName = "";
  let processorAddress = "";
  let address = "";
  let viewingGrowerName = "";
  let viewingGrowerId = "";
  let viewingProcessorId = "";
  let isManager = false;
  let isInvalidProcessor = false;
  let referenceUserId = "";
  let currentUserId = "";
  let currentUserName = "";
  let currentUserRole = "";
  let currentUserAvatar = "/assets/images/avatar-default.png";
  let isDisabled = false;
  let expiredMessage = "";
  let titerInfo = {};
  const tokens = localStorage.getItem("tokens");
  if (
    tokens != null &&
    tokens !== undefined &&
    tokens.toString() !== "undefined" &&
    tokens.toString() !== ""
  ) {
    const token = jwt_decode(tokens);
    const existingTokens = token;
    if (existingTokens) {
      processorId = existingTokens.processorId;

      processorAddress = existingTokens.processorAddress;
      processorName = existingTokens.processorName;
      address = existingTokens.address;
      isInvalidProcessor = existingTokens.isInvalidProcessor;
      processorCertificateNo = existingTokens.processorCertificateNo;
      processorCertificatePrefix = existingTokens.processorCertificatePrefix;
      processorCertificateSeed = existingTokens.processorCertificateSeed;
      viewingGrowerName = existingTokens.viewingGrowerName;
      viewingGrowerId = existingTokens.viewingGrowerId;
      isManager = existingTokens.isManager;
      viewingProcessorId = existingTokens.viewingProcessorId;

      referenceUserId = existingTokens.referenceUserId;
      currentUserId = existingTokens._id;
      currentUserName = existingTokens.name;
      currentUserRole = existingTokens.role;
      // currentUserAvatar = existingTokens.avatar;
      isDisabled = existingTokens.isDisabled;
      expiredMessage = existingTokens.expiredMessage;
      titerInfo = existingTokens.titerInfo;
    }
  }
  return {
    processorId: processorId,
    processorAddress: processorAddress,
    processorName: processorName,
    processorCertificateNo: processorCertificateNo,
    processorCertificatePrefix: processorCertificatePrefix,
    processorCertificateSeed: processorCertificateSeed,
    address: address,
    viewingGrowerName: viewingGrowerName,
    viewingGrowerId: viewingGrowerId,
    viewingProcessorId: viewingProcessorId,
    isManager: isManager,
    isInvalidProcessor: isInvalidProcessor,
    referenceUserId: referenceUserId,
    _id: currentUserId,//account id
    name: currentUserName,
    role: currentUserRole,
    avatar: currentUserAvatar,
    isDisabled: isDisabled,
    expiredMessage: expiredMessage,
    titerInfo: titerInfo,
  };
};

export const isActive = () => {
  const x = localStorage.getItem("isActive");
  if (x) {
    return x === true || x === "true";
  }
  return false;
};
